import { Detention, CreateDetentionDto, UpdateDetentionDto, DetentionLumperStatus } from "../types/detention";
import { unwrapApiResponse } from "../utils/apiUtils";
import { api } from "./apiSlice";

const detectionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDetentions: builder.query<Detention[], void>({
      query: () => "detentions",
      transformResponse: unwrapApiResponse,
      providesTags: ["Detentions"],
    }),
    getDetentionById: builder.query<Detention, number>({
      query: (id) => `detentions/${id}`,
      transformResponse: unwrapApiResponse,
      providesTags: (result, error, id) => [{ type: "Detentions", id }],
    }),
    createDetention: builder.mutation<Detention, { dto: CreateDetentionDto; document?: File }>({
      query: ({ dto, document }) => {
        const formData = new FormData();
        Object.entries(dto).forEach(([key, value]) => {
          if (value === undefined || value === null) return;
          if (typeof value === "boolean") {
            formData.append(key, String(value));
            return;
          }
          if (value === "") return;
          formData.append(key, String(value));
        });
        if (document) formData.append("document", document);
        return { url: "detentions", method: "POST", body: formData };
      },
      transformResponse: unwrapApiResponse,
      invalidatesTags: ["Detentions"],
    }),
    updateDetention: builder.mutation<Detention, { id: number } & UpdateDetentionDto>({
      query: ({ id, ...body }) => ({ url: `detentions/${id}`, method: "PUT", body }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: (_r, _e, { id }) => ["Detentions", { type: "Detentions", id }],
    }),
    updateDetentionStatus: builder.mutation<Detention, { id: number; status: DetentionLumperStatus }>({
      query: ({ id, status }) => ({ url: `detentions/${id}/status`, method: "PATCH", body: { status } }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: (_r, _e, { id }) => ["Detentions", { type: "Detentions", id }],
    }),
    deleteDetention: builder.mutation<void, number>({
      query: (id) => ({ url: `detentions/${id}`, method: "DELETE" }),
      transformResponse: () => undefined,
      invalidatesTags: ["Detentions"],
    }),
  }),
});

export const {
  useGetDetentionsQuery,
  useGetDetentionByIdQuery,
  useCreateDetentionMutation,
  useUpdateDetentionMutation,
  useUpdateDetentionStatusMutation,
  useDeleteDetentionMutation,
} = detectionsApi;
